var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"barBox",style:(_vm.getBg),attrs:{"title":_vm.tips}},[_c('div',{staticClass:"progress",style:(_vm.getRate)})])}
var staticRenderFns = []

export { render, staticRenderFns }